//import Vue from 'vue'

const state = {
}

const getters = {
//    type2variant(state) {
//        return (type) => {
//            const table = {
//                'from': 'primary',
//                'to': 'success',
//                'importer': 'info',
//            }
//            return table[type]
//        }
//    },
}

const mutations = {
}

const actions = {
    async save (context, data) {
        return axios.post('/api/v1/listing_html' + (data.id ? '/' + data.id : ''), data)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })

    },
    async destroy (context, data) {
        if (data.id === undefined) {
            return {
                data: {
                    data: {
                    },
                },
            }
        }
        const response = await axios.delete('/api/v1/listing_html/' + data.id)
            .catch(error => error.response || null)
        return response
    },
    async index (context, data) {
        const response = await axios.get('/api/v1/listing_html' + (typeof data  === 'string' ? '/' + data : ''), {
            params: (typeof data === 'object' ? data : null)
        })
        .catch(error => error.response || null)
        return response
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

